
import cal from 'generate-calendar-url'

const attribute = 'data-calendar-button'
const selector = `[${attribute}]`

const init = button => {
	const data = JSON.parse(button.getAttribute(attribute))
	const link = cal.outlook({
		...data,
		start: new Date(data.startDate || ''),
		end: new Date(data.endDate || ''),
	})
	button.href = link
	if (!link) button.remove()	
}

export default () => {
	[...document.querySelectorAll(selector)].map(init)
}